import axios from 'axios';
import router from '@/router';
// import { useToolStore } from '@/store/tool';
import { Settings } from '@/settings';
import { showToast } from '../element';
import {
  getToken,
  removeToken,
  removeMainListMode,
  removeDetailInfoMode,
  removeIsFather,
  removeIsPicture,
  removeIsDialog
} from '../token';
import { showStatusMessage } from './status';

/** 超时时长 */
const TIME_OUT = 60 * 5;

/** 请求映射表 */
const reqMap = new Map();

const request = axios.create({
  baseURL: '',
  timeout: TIME_OUT * 1000
});

request.interceptors.request.use(
  config => {
    // if (
    //   config.url.includes('Upload/UploadFolderToOssByStream') ||
    //   config.url.includes('Upload/UploadFolderToOssByStreamSimple') ||
    //   config.url.includes('Upload/DownLoadFolderToOssByStream')
    // ) {
    //   const toolStore = useToolStore();
    //   toolStore.changePenddingNum('start');
    // }

    const token = getToken();
    if (token) {
      // 请求头中带上token
      config.headers.Authorization = `${token}`;
    }
    cancelRepeat(config);
    return config;
  },
  error => Promise.reject(error)
);

request.interceptors.response.use(
  response => {
    // if (
    //   response.config.url.includes('Upload/UploadFolderToOssByStream') ||
    //   response.config.url.includes('Upload/UploadFolderToOssByStreamSimple') ||
    //   response.config.url.includes('Upload/DownLoadFolderToOssByStream')
    // ) {
    //   const toolStore = useToolStore();
    //   toolStore.changePenddingNum('end');
    // }
    // 200
    if (response.status === 200 || response.data.code === 200) {
      if (response.config.responseType === 'blob') return response;
      if (response.config.responseType === 'arraybuffer') return response;

      if (!response.data.isOK && !response.config.url.includes('Captcha')) {
        showToast({
          type: 'error',
          message: response.data.Message || response.data.message
        });
      }

      return response.data;
    }
    // 401
    if (response.status === 401) {
      showToast({ type: 'error', message: response.data.message });
      removeToken();
      removeMainListMode();
      removeDetailInfoMode();
      removeIsFather();
      removeIsPicture();
      removeIsDialog();
      if (Settings.autoReAuthorize) {
        router.push('/auth');
      } else {
        router.push('/401');
      }
      return Promise.reject(new Error('身份认证失败'));
    }
    const message = showStatusMessage(response);
    return Promise.reject(message);
  },
  error => {
    // if (
    //   error.config.url.includes('Upload/UploadFolderToOssByStream') ||
    //   error.config.url.includes('Upload/UploadFolderToOssByStreamSimple') ||
    //   error.config.url.includes('Upload/DownLoadFolderToOssByStream')
    // ) {
    //   const toolStore = useToolStore();
    //   toolStore.changePenddingNum('end');
    // }

    // 401
    if (error.response?.status === 401) {
      showToast({ type: 'error', message: error.response.data.message });
      removeToken();
      removeMainListMode();
      removeDetailInfoMode();
      removeIsFather();
      removeIsPicture();
      removeIsDialog();
      if (Settings.autoReAuthorize) {
        router.push('/auth');
      } else {
        router.push('/401');
      }
      return Promise.reject(new Error('身份认证失败'));
    }
    if (error.response?.status === 500) {
      const message = error.response.data.Message || error.response.data.message;
      if (!error.config.hideError) {
        showToast({ type: 'error', message });
      }
      return Promise.reject(message);
    }
    // 出错状态码处理
    const message = error.message ?? showStatusMessage(error.response);
    return Promise.reject(message);
  }
);

/**
 * 取消重复请求
 * @param config axios配置
 */
function cancelRepeat(config) {
  if (config.cancelRepeat) {
    const key = config.url;
    if (reqMap.has(key)) {
      reqMap.get(key).cancel('取消重复请求');
    }
    reqMap.set(key, axios.CancelToken.source());
    config.cancelToken = reqMap.get(key).token;
  }
}

export default request;
